var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$store.getters.loggedIn)?_c('secure-main',{attrs:{"errorMessageObj":_vm.errorMessageObj}}):_c('login')
}
var staticRenderFns = []

export { render, staticRenderFns }